import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { JsonEditorDialogComponent } from './json-editor-dialog.component';

@Injectable()
export class JsonEditorDialogService extends AbstractDialogService<string, string> {
  readonly id = 'json-editor-dialog';
  protected readonly component = JsonEditorDialogComponent;

  override readonly options = {
    cssClass: 'modified-modal  fullscreen action-sheet-on-mobile',
  };

  protected override readonly dismissOnBreakpointChange = true;

  override openDialog({ input: data }: { input: string; options?: DialogOptions }) {
    return super.openDialog({ options: { ...this.options, componentProps: { data } } });
  }
}
